import { lazy } from "react";

export const CustomInput = lazy(() => import("./CustomInput"));
export const CustomSelectInput = lazy(() => import("./CustomSelectInput"));
